import {
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  FormControlLabel,
  FormHelperText,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Redirect, useLocation } from "react-router-dom";
import ConfirmationModal from "../../Components/Modal/Modal";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import Signifier from "../../Components/Signifier";
import { StyledTextField } from "../../Components/TextField/TextField";
import {
  deleteInboundFeed,
  editInboundFeed,
} from "../../Services/API/InboundFeeds";
import { selectUserInformation } from "../../State/Slices/UserInformationSlice";
import prettifyXml from "prettify-xml/dist";

function InboundFeedDetailed() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "90%",
      marginBottom: "50px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    sensitiveSection: {
      width: "100%",
      height: "25%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      paddingTop: "20px",
    },
    sensitiveButton: {
      [theme.breakpoints.down("sm")]: {
        maxWidth: "none",
        width: "100%",
      },
      width: "200px",
    },
    error: {
      color: theme.palette.error.main,
    },
    textField: {
      "& .Mui-error": {
        color: theme.palette.error.main,
      },
      "& .MuiFormHelperText-root": {
        color: theme.palette.error.main,
      },
      "& .MuiInput-underline.Mui-error:after": {
        borderBottomColor: theme.palette.error.main,
      },
    },
    header: {
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        marginTop: "10px",
      },
      display: "flex",
    },
    descLabel: {
      margin: "0px",
      fontWeight: "700",
      marginBottom: "10px",
    },
    descValue: {
      margin: "0px",
      marginLeft: "5px",
      marginRight: "20px",
    },
    descBlock: {
      display: "flex",
    },
  }));

  const classes = useStyles();

  let location = useLocation();
  const userEmail = useSelector(selectUserInformation).email;
  const [showSignifier, setShowSignifier] = useState(false);
  const [showError, setShowError] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [name, setName] = useState(
    location.state === undefined ? "" : location.state.feedName
  );
  const [url, setURL] = useState(
    location.state === undefined ? "" : location.state.feedUrl
  );
  const [sourceFile, setSourceFile] = useState(
    location.state === undefined ? "" : location.state.sourceFileFullPath
  );
  const [fileType, setFileType] = useState(
    location.state === undefined ? "" : location.state.sourceFileType
  );
  const [transform, setTransform] = useState(
    location.state === undefined ? "" : location.state.transform
  );
  const [isActive, setIsActive] = useState(
    location.state === undefined ? "" : location.state.isActive
  );
  const [isCompressed, setIsCompressed] = useState(
    location.state === undefined ? "" : location.state.isCompressed
  );
  const [showInputError, setShowInputError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [deleted, setDeleted] = useState(false);

  if (location.state === undefined) {
    return <Redirect to="/inboundfeeds" />;
  }

  const data = {
    Id: location.state === undefined ? "" : location.state.id,
    FeedName: name,
    FeedUrl: url,
    SourceFileFullPath: sourceFile,
    SourceFileType: fileType,
    IsActive: isActive,
    IsCompressed: isCompressed,
    LastUpdatedBy: userEmail,
    Transform: transform,
  };

  const checkAllEntered = () => {
    if (name === "" || fileType === "") {
      return false;
    }
    return true;
  };

  const convertDate = (date) => {
    var newDate = new Date(date).toLocaleDateString("en-US");
    return newDate;
  };

  const callAPI = (func, responseMessage) => {
    setProcessing(true);
    func.then((res) => {
      setShowSignifier(true);
      if (res) {
        setResponseMessage(responseMessage);
        setShowError(false);
      } else {
        setShowError(true);
      }
      setProcessing(false);
    });
  };

  const callDelete = async () => {
    await deleteInboundFeed(location.state.id).then((response) => {
      if (response) {
        setDeleted(true);
        return true;
      }
    });
    return true;
  };

  if (deleted) {
    return <Redirect to="/inboundfeeds" />;
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">Detailed Inbound Feed</h1>
        <div className={classes.header}>
          <div className={classes.descBlock}>
            <p className={classes.descLabel}>DATE CREATED: </p>
            <p className={classes.descValue}>
              {convertDate(location.state.dateCreated)}
            </p>
          </div>
          <div className={classes.descBlock}>
            <p className={classes.descLabel}>LAST UPDATED BY: </p>
            <p className={classes.descValue}>{location.state.lastUpdatedBy}</p>
          </div>
        </div>
        <div className={classes.root}>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid xs={12} sm={6} item>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Name"
                      label="Name"
                      variant="standard"
                      fullWidth
                      required
                      value={name}
                      error={showInputError && name === ""}
                      className={classes.textField}
                      onChange={(e) => setName(e.target.value)}
                    />
                    {showInputError && name === "" && (
                      <FormHelperText className={classes.error}>
                        Name Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="URL"
                      label="URL"
                      variant="standard"
                      fullWidth
                      required
                      value={url}
                      onChange={(e) => setURL(e.target.value)}
                    />
                  </Grid>
                  <Grid xs={12} sm={6} item>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Source File"
                      label="Source File"
                      variant="standard"
                      fullWidth
                      required
                      value={sourceFile}
                      onChange={(e) => setSourceFile(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="File Type"
                      label="File Type"
                      variant="standard"
                      fullWidth
                      required
                      value={fileType}
                      error={showInputError && fileType === ""}
                      className={classes.textField}
                      onChange={(e) => setFileType(e.target.value)}
                    />
                    {showInputError && fileType === "" && (
                      <FormHelperText className={classes.error}>
                        File Type Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid xs={12} sm={12} item>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={isActive}
                          onChange={(e) => setIsActive(!isActive)}
                        />
                      }
                      label="Active"
                    />
                  </Grid>
                  <Grid xs={12} sm={12} item>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={isCompressed}
                          onChange={(e) => setIsCompressed(!isCompressed)}
                        />
                      }
                      label="Compressed"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Transform"
                      label="Transform"
                      variant="standard"
                      fullWidth
                      multiline
                      rows={1}
                      rowsMax={20}
                      required
                      inputProps={{ spellCheck: false }}
                      value={
                        transform !== null ? prettifyXml(transform, { newline: '\n' }) : transform
                      }
                      onChange={(e) => setTransform(e.target.value)}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    justifyContent="flex-end"
                  >
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        checkAllEntered()
                          ? callAPI(editInboundFeed(data), "Feed Saved")
                          : setShowInputError(true)
                      }
                    >
                      Save Information
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <div className={classes.sensitiveSection}>
              <Grid
                item
                xs={12}
                sm={12}
                container
                justifyContent="space-between"
              >
                <Button
                  className={classes.sensitiveButton}
                  type="submit"
                  variant="contained"
                  color="secondary"
                  onClick={() => setOpenModal(true)}
                >
                  Delete API
                </Button>
              </Grid>
            </div>
          </Grid>
        </div>
      </div>
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <ConfirmationModal
          question="Delete this feed permanently?"
          func={() => callAPI(callDelete(), "Feed Deleted")}
          closeModal={() => setOpenModal(false)}
          processing={processing}
        />
      </Dialog>
    </>
  );
}

export default InboundFeedDetailed;
